import type { RouteObject } from 'react-router';

import { ExceptionsGate } from './components/ExceptionsGate';

/**
 * `/exceptions` and `/exceptions/:id`, code-split per route, `exception:read`
 * on both.
 *
 * The two paths are declared **absolutely and separately** rather than as one
 * nested branch, because `app/router.tsx` drops a placeholder route only when a
 * feature claims that exact `path` string. A nested `:id` would leave the
 * `/exceptions/:id` placeholder in the table, shadowed but present.
 */
export const routes: RouteObject[] = [
  {
    path: '/exceptions',
    Component: ExceptionsGate,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./ExceptionsQueuePage')).ExceptionsQueuePage,
        }),
      },
    ],
  },
  {
    path: '/exceptions/:id',
    Component: ExceptionsGate,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./ExceptionDetailPage')).ExceptionDetailPage,
        }),
      },
    ],
  },
];
